/* BHALLO — ponte do tema para o checkout da Yampi.

   POR QUE ISSO EXISTE (nao apagar sem ler):

   1. O script da Yampi so sequestra o checkout quando a pessoa esta na pagina
      "/cart". Nossa loja usa carrinho lateral (drawer), que nunca abre essa
      pagina — entao o botao "Finalizar a compra" ia direto pro checkout da
      Shopify, ignorando a Yampi.

   2. O trecho da Yampi que criaria um botao "Comprar agora" na pagina de
      produto esta dentro de um "if (window.$ || window.jQuery)". O Dawn nao
      tem jQuery, entao aquele pedaco nunca roda.

   3. O /status da Yampi responde pelo dominio da barra do navegador
      (bhallo-2.myshopify.com) e a conta esta registrada no dominio permanente
      da loja (3irjkt-dt.myshopify.com), entao ela se declara inativa aqui.
      O endpoint de carrinho, porem, funciona quando recebe os dois dominios.

   O que fazemos: pedimos pra Yampi a URL de checkout do carrinho atual,
   mandando os dois dominios, e levamos o cliente pra la. E o mesmo que o
   codigo da propria Yampi faz na pagina /cart.

   Se qualquer coisa falhar, o cliente segue pelo caminho normal da Shopify —
   melhor um checkout diferente do que um botao morto. */
(function () {
  var ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var TEMPO_LIMITE = 8000;
  var indo = false;

  function dominioPermanente() {
    return (window.Shopify && window.Shopify.shop) || window.location.host;
  }

  /* Pergunta a URL do checkout pra Yampi e leva o cliente.
     aoFalhar(): o que fazer se a Yampi nao responder ou disser que esta off. */
  function irParaCheckout(aoFalhar) {
    if (indo) return;
    indo = true;

    var acabou = false;
    function desistir() {
      if (acabou) return;
      acabou = true;
      indo = false;
      if (typeof aoFalhar === 'function') aoFalhar();
    }

    var relogio = setTimeout(desistir, TEMPO_LIMITE);

    fetch('/cart.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop: window.location.host,
            shopify_internal_domain: dominioPermanente(),
            cart_payload: carrinho
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (acabou) return;

        if (resp && resp.active && resp.checkout_direct_url) {
          acabou = true;
          clearTimeout(relogio);
          var url = resp.checkout_direct_url;
          // a Yampi guarda utms num cookie e injeta na url do checkout;
          // se a funcao dela existir na pagina, reaproveitamos
          if (typeof window.ymp_getUrlWithUtms === 'function') {
            try { url = window.ymp_getUrlWithUtms(url); } catch (err) {}
          }
          window.location.href = url;
        } else {
          clearTimeout(relogio);
          desistir();
        }
      })
      .catch(function () {
        clearTimeout(relogio);
        desistir();
      });
  }

  // ---- 1. Botao "Finalizar a compra" (drawer, /cart e popup de adicionado) ----
  // Intercepta o checkout em QUALQUER pagina, inclusive /cart. Sem isso, a
  // pagina /cart mandava o cliente pro checkout da Shopify (furava a Yampi).
  document.addEventListener(
    'click',
    function (e) {
      var alvo = e.target.closest && e.target.closest('[name="checkout"]');
      if (!alvo || indo) return;

      e.preventDefault();
      e.stopPropagation();

      var texto = alvo.textContent;
      if (alvo.tagName === 'BUTTON') alvo.textContent = 'Aguarde...';
      alvo.setAttribute('aria-busy', 'true');

      irParaCheckout(function () {
        // Yampi fora do ar: deixa a Shopify assumir em vez de travar a venda
        if (alvo.tagName === 'BUTTON') alvo.textContent = texto;
        alvo.removeAttribute('aria-busy');
        if (alvo.form) alvo.form.submit();
      });
    },
    true
  );

  // ---- 2. Botao "Comprar agora" da pagina de produto ----
  // Adiciona a variante escolhida e vai direto pro checkout, pulando o carrinho.
  function ligarComprarAgora() {
    var btn = document.getElementById('BhalloBuyNow');
    if (!btn) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    var real = document.querySelector('.product-form__submit');
    if (!form || !real) {
      btn.remove();
      return;
    }

    // se a variante escolhida esgotou, o "Comprar agora" acompanha o botao real
    function sincronizar() {
      btn.disabled = real.disabled;
    }
    sincronizar();
    if (window.MutationObserver) {
      new MutationObserver(sincronizar).observe(real, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var texto = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Aguarde...';

      function voltar() {
        btn.disabled = false;
        btn.textContent = texto;
      }

      var dados = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: dados, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('nao entrou no carrinho');
          // ja esta no carrinho: agora pede a url da Yampi
          irParaCheckout(function () {
            // Yampi fora: cai no checkout da Shopify, que ao menos vende
            window.location.href = '/checkout';
          });
        })
        .catch(function () {
          voltar();
          // nao conseguiu adicionar: devolve o cliente pro botao normal
          real.click();
        });
    });
  }

  if (document.readyState !== 'loading') ligarComprarAgora();
  else document.addEventListener('DOMContentLoaded', ligarComprarAgora);
})();
